import React, { Component } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import NavBar from "../../components/navbar";
import { Link } from "react-router-dom";

import {
  findObjectUseCase,
  countObjectUseCase,
  deleteObjectUseCase,
} from "../../usecases/object";
import BaseListPage from "../../base/BaseListPage";
import AccountingCalendarPresenter from "./AccountingCalendarPresenter";

// Initialize moment localizer
moment.suppressDeprecationWarnings = true;
const localizer = momentLocalizer(moment);

class AccountingCalendar extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new AccountingCalendarPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase()
    );

    this.state = {
      events: this.props.initialEvents || [],
      view: "month",
    };
  }

  getCollectionName = () => "employees";
  getKeys = () => [];
  setTotal = (total) => console.log("Total events:", total);
  setObjects = (objects) => {
    console.log("Set objects:", objects);
    const formattedEvents = this.processEventsArray(objects);
    this.setState({ events: formattedEvents });
  };
  showError = (error) => console.error("Error:", error);

  componentDidMount() {
    this.fetchEvents();

    // Apply custom styling
    const style = document.createElement("style");
    style.innerHTML = `
    .rbc-month-view, .rbc-time-view, .rbc-day-view .rbc-time-view,
    .rbc-work-week-view .rbc-time-view, .rbc-agenda-view {
      background-color: #f8f8f8 !important;
    }
    .rbc-toolbar button {
      background-color: #f8f8f8 !important;
    }
    `;
    document.head.appendChild(style);
  }

  createEventObject = (employee) => {
    try {
      if (!employee.lastPayDate) {
        return null;
      }

      const startDate = new Date(employee.lastPayDate);
      if (isNaN(startDate.getTime())) {
        console.error(
          "Invalid date format for employee lastPayDate:",
          employee
        );
        return null;
      }

      // Create start and end DateTimes
      const startDateTime = new Date(startDate);
      startDateTime.setHours(9, 0, 0, 0); // Default to 9:00 AM

      const endDateTime = new Date(startDate);
      endDateTime.setHours(10, 0, 0, 0); // Default to 10:00 AM

      // Construct full name
      const firstName = employee.firstName || "";
      const middleName = employee.middleName ? `${employee.middleName} ` : "";
      const lastName = employee.lastName || "";
      const fullName = `${firstName} ${middleName}${lastName}`.trim();

      const title = fullName || "Last Pay Processing";

      return {
        id:
          employee.id ||
          `event-${Date.now()}-${Math.random().toString(36).substr(2, 5)}`,
        title: title,
        start: startDateTime,
        end: endDateTime,
        allDay: false,
        originalEmployee: employee,
      };
    } catch (error) {
      console.error("Error processing employee:", error, employee);
      return null;
    }
  };

  processEventsArray = (employeesArray) => {
    if (!Array.isArray(employeesArray)) {
      console.error("Expected array but got:", typeof employeesArray);
      return [];
    }
    return employeesArray
      .filter(
        (employee) => employee.status === "For Last Pay" && employee.lastPayDate
      )
      .map(this.createEventObject)
      .filter((event) => event !== null);
  };

  fetchEvents = async () => {
    try {
      const employeesData = await this.presenter.getLastPayEmployees();
      console.log("Loaded employees data:", employeesData);

      const formattedEvents = this.processEventsArray(employeesData);
      console.log("Final formatted events:", formattedEvents);
      this.setState({ events: formattedEvents });
    } catch (error) {
      console.error("Error loading events:", error);
      this.setState({ events: [] });
    }
  };

  eventStyleGetter = (event) => {
    const style = {
      backgroundColor: "#D18237", // Last Pay color
      borderRadius: "3px",
      opacity: 0.85,
      color: "white",
      border: "0",
      display: "block",
      fontSize: "0.85em",
      overflow: "hidden",
      textOverflow: "ellipsis",
      padding: "2px 5px",
      margin: "0",
      cursor: "pointer",
      width: "100%",
      position: "absolute",
      boxSizing: "border-box",
    };

    if (this.state.view === "month") {
      style.height = "auto";
      style.position = "relative";
    } else if (this.state.view === "agenda") {
      style.position = "relative";
      style.width = "100%";
      style.margin = "2px 0";
      style.height = "auto";
    }

    return { style };
  };

  handleViewChange = (newView) => this.setState({ view: newView });

  // handleEventClick = (event) => {
  //   if (event.originalEmployee && event.originalEmployee.id) {
  //     this.navigateTo(`/employee/detail/${event.originalEmployee.id}`);
  //   } else {
  //     alert("Cannot navigate: Missing employee details");
  //   }
  // };

  renderLegend = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "15px",
          position: "absolute",
          right: "30px",
          top: "106px",
          background: "#f8f8f8",
          padding: "10px 15px",
          borderRadius: "8px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <div
            style={{
              width: "20px",
              height: "20px",
              backgroundColor: "#D18237",
              borderRadius: "4px",
              marginRight: "8px",
            }}
          ></div>
          <span style={{ fontSize: "14px", fontWeight: "500" }}>Last Pay</span>
        </div>
      </div>
    );
  };

  render() {
    const {
      height = "800px",
      hiddenHours = [1, 3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23],
    } = this.props;
    const events = Array.isArray(this.state.events) ? this.state.events : [];

    return (
      <>
        <NavBar />
        <div style={{ padding: "25px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              marginBottom: "30px",
              marginTop: "10px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              {/* <Link to="/dashboard">
                <div
                  style={{
                    backgroundColor: "#E6E6E6",
                    borderRadius: "50%",
                    padding: "6px 11px",
                    marginRight: "10px",
                  }}
                >
                  <i
                    className="bi bi-arrow-left"
                    style={{
                      fontSize: "20px",
                      cursor: "pointer",
                      fontWeight: "bold",
                    }}
                  ></i>
                </div>
              </Link> */}
              <div>
                <h2
                  style={{
                    color: "#D18237",
                    margin: 0,
                    fontSize: "20px",
                    fontWeight: "bold",
                  }}
                >
                  Last Pay Calendar
                </h2>
                <p style={{ margin: 0, color: "#555", fontSize: "15px" }}>
                  Accounting Department
                </p>
              </div>
            </div>
            {this.renderLegend()}
          </div>

          <Calendar
            localizer={localizer}
            events={events}
            startAccessor="start"
            endAccessor="end"
            selectable
            onSelectSlot={this.handleSelect}
            onSelectEvent={this.handleEventClick}
            defaultView="month"
            views={{
              month: true,
              week: true,
              work_week: true,
              day: true,
              agenda: true,
            }}
            onView={this.handleViewChange}
            eventPropGetter={this.eventStyleGetter}
            step={60}
            timeslots={2}
            formats={{
              timeGutterFormat: (date, culture, localizer) =>
                hiddenHours.includes(moment(date).hour())
                  ? ""
                  : localizer.format(date, "h:mm A", culture),
              eventTimeRangeFormat: ({ start, end }, culture, localizer) =>
                localizer.format(start, "h:mm A") +
                " - " +
                localizer.format(end, "h:mm A"),
            }}
            style={{ height }}
            min={new Date(0, 0, 0, 0, 0, 0)}
            max={new Date(0, 0, 0, 23, 59, 59)}
            dayLayoutAlgorithm="no-overlap"
            resizable
            showMultiDayTimes={true}
            slotPropGetter={(date) => ({
              style: {
                backgroundColor:
                  date.getMinutes() === 0
                    ? "rgba(240, 240, 240, 0.2)"
                    : "rgba(248, 248, 248, 0.2)",
              },
            })}
          />
        </div>
      </>
    );
  }
}

export default AccountingCalendar;
